/*
 * @Date: 2025-07-11 10:27:17
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2025-07-14 15:21:30
 * @FilePath: \cms_main_site\src\directs\sizeDirect.js
 */
const map = new WeakMap()
const ob = new ResizeObserver((entries) => {
  for (const entry of entries) {
    // const binding = map.get(entry.target)
    if (map.has(entry.target)) {
      const callback = map.get(entry.target)
      if (typeof callback === 'function') {
        callback(entry.contentRect)
      }
    }
  }
})
const resize = {
  bind (el, binding) {
    ob.observe(el)
    map.set(el, binding.value)
  },
  unbind (el) {
    ob.unobserve(el)
  }
}

export default {
  install: (app) => {
    app.directive('resize', resize)
  }
}
